// Cupom divulgado no site (2026-10-25). Funções PURAS:
//  - parseCouponParam: lê ?cupom=CODIGO da URL (link de campanha/recuperação);
//  - pickFirstPurchasePromo: escolhe o cupom de primeira compra que pode ir no
//    selo da página de produto. Só cupom ativo, dentro das datas e SEM
//    restrição de produto/categoria/marca/valor mínimo -- assim o selo nunca
//    promete um desconto que o checkout recusaria para aquele produto.
//    A validação de verdade continua no servidor, ao aplicar.

const CODE = /^[A-Za-z0-9_-]{2,40}$/;

export function parseCouponParam(search: string): string | null {
  const raw = new URLSearchParams(search).get("cupom");
  const code = raw?.trim() ?? "";
  return CODE.test(code) ? code.toUpperCase() : null;
}

export interface PromoCouponRow {
  code: string;
  kind: string;
  percentBps: number | null;
  amountMinor: number | null;
  status: string;
  firstPurchaseOnly: boolean;
  startsAt: Date | null;
  endsAt: Date | null;
  minSubtotalMinor: number | null;
  restricted: boolean;
}

export interface FirstPurchasePromo {
  code: string;
  /** Ex.: "10% OFF" ou "R$ 20 OFF". */
  label: string;
}

function brlShort(minor: number): string {
  const value = minor / 100;
  return `R$ ${Number.isInteger(value) ? value : value.toFixed(2).replace(".", ",")}`;
}

export function pickFirstPurchasePromo(rows: readonly PromoCouponRow[], now: Date): FirstPurchasePromo | null {
  const valid = rows.filter((row) =>
    row.status === "active" && row.firstPurchaseOnly && !row.restricted && !row.minSubtotalMinor
    && (!row.startsAt || row.startsAt <= now) && (!row.endsAt || row.endsAt > now)
    && ((row.kind === "percentage" && (row.percentBps ?? 0) > 0) || (row.kind === "fixed_cart" && (row.amountMinor ?? 0) > 0)));
  if (!valid.length) return null;
  // Maior percentual primeiro; depois o maior valor fixo.
  valid.sort((a, b) => (b.percentBps ?? 0) - (a.percentBps ?? 0) || (b.amountMinor ?? 0) - (a.amountMinor ?? 0) || a.code.localeCompare(b.code));
  const row = valid[0];
  const label = row.kind === "percentage"
    ? `${Number(((row.percentBps ?? 0) / 100).toFixed(2)).toString().replace(".", ",")}% OFF`
    : `${brlShort(row.amountMinor ?? 0)} OFF`;
  return { code: row.code.toUpperCase(), label };
}
